import { formatDistanceToNow } from 'date-fns'

import { Badge } from '@/components/ui/badge'
import { Card, CardContent } from '@/components/ui/card'
import { cn } from '@/lib/utils'
import type { Machine } from '../types'

interface MachineCardProps {
  machine: Machine
  onSelect: (machine: Machine) => void
}

export function MachineCard({ machine, onSelect }: MachineCardProps) {
  const enabled = machine.config?.enabled ?? true
  const lastSeen = machine.last_seen_at
    ? formatDistanceToNow(new Date(machine.last_seen_at), { addSuffix: true })
    : 'never seen'
  return (
    <Card
      className="cursor-pointer overflow-hidden py-0 transition-shadow hover:shadow-md"
      onClick={() => onSelect(machine)}>
      <div className="aspect-video w-full bg-muted">
        {machine.screenshot_url ? (
          <img
            src={machine.screenshot_url}
            alt={`${machine.machine_id} screen`}
            className="h-full w-full object-cover"
          />
        ) : (
          <div className="flex h-full w-full items-center justify-center text-xs text-muted-foreground">
            No screenshot yet
          </div>
        )}
      </div>
      <CardContent className="space-y-2 p-3">
        <div
          className="truncate text-sm font-medium"
          title={machine.machine_id}>
          {machine.machine_id}
        </div>
        <div className="flex items-center justify-between gap-2 text-xs text-muted-foreground">
          <span className="flex items-center gap-2">
            <span className="flex items-center gap-1.5">
              <span
                aria-hidden
                className={cn(
                  'h-2 w-2 shrink-0 rounded-full',
                  enabled ? 'bg-green-500' : 'bg-muted-foreground/40'
                )}
              />
              {enabled ? 'Enabled' : 'Disabled'}
            </span>
            <Badge variant={machine.env === 'prod' ? 'default' : 'secondary'}>
              {machine.env}
            </Badge>
          </span>
          <span className="truncate">{lastSeen}</span>
        </div>
      </CardContent>
    </Card>
  )
}
